import Entity from '@/models/entities/Entity';
import { ColorGroup } from '@/models/entities/ColorGroup';
import { FontGroup } from '@/models/entities/FontGroup';
import { ProductCategoryOption } from '@/models/entities/ProductCategoryOption';
import { ProductCategoryAttribute } from '@/models/entities/ProductCategoryAttribute';
import { QuantityBreak } from '@/models/entities/QuantityBreak';
import { ImageFile } from '@/models/entities/ImageFile';

export class Category implements CategoryPreview {
  public id: number = 0;
  public name: string = '';
  public position: number = 0;
  public thumbImage: ImageFile = new ImageFile({});
  public colorGroup?: ColorGroup;
  public fontGroup?: FontGroup;
  public description: string = '';
  public parentCategory?: CategoryPreview;
  public subCategoriesAmount: number = 0;
  public prices: {
    price: number;
    quantityBreak: QuantityBreak;
  }[] = [];
  public productCategoryOptions: ProductCategoryOption[] = [];
  public productCategoryAttributes: ProductCategoryAttribute[] = [];
  public active: boolean = true;
  public sizeChart: string[][] = [];
  public designerUrl: string = '';

  constructor(initData: Partial<Category>) {
    Object.assign(this, initData);
  }
}

export class CategoryPreview implements Entity {
  public id: number = 0;
  public name: string = '';

  constructor(initData: Partial<CategoryPreview>) {
    Object.assign(this, initData);
  }
}
